import { Flex, Table, Tag, Typography } from 'antd';
import { FC, memo } from 'react';
import { ArrowRightShort } from 'react-bootstrap-icons';

import { ParsedRedirectRow } from '@/modules/Sites/Redirects';

interface Props {
  rows: ParsedRedirectRow[];
  loading?: boolean;
}

export const RedirectsBulkPreviewTable: FC<Props> = memo(({ rows, loading }) => {
  return (
    <Table<ParsedRedirectRow>
      size="small"
      rowKey="key"
      dataSource={ rows }
      loading={ loading }
      pagination={ { pageSize: 100, showSizeChanger: false, } }
      scroll={{ y: 420 }}
      locale={{ emptyText: 'Тут зʼявиться попередній перегляд' }}
      columns={ [
        { title: '№', dataIndex: 'index', width: 48 },
        {
          title: 'Редірект',
          dataIndex: 'pathFrom',
          render: (_, { pathFrom, pathTo, raw }) =>
            pathFrom && pathTo ? (
              <Flex gap={ 4 } align="center" wrap="wrap">
                <Typography.Text>{ pathFrom }</Typography.Text>
                <ArrowRightShort size={ 12 }/>
                <Typography.Text>{ pathTo }</Typography.Text>
              </Flex>
            ) : (
              <Typography.Text type="secondary" delete>{ raw }</Typography.Text>
            ),
        },
        {
          title: 'Буде надіслано',
          dataIndex: 'pathFrom',
          width: 150,
          render: (_, { pathFrom, pathTo }) =>
            pathFrom && pathTo ? (
              <Tag color="green">Так</Tag>
            ) : (
              <Tag color="default">Ні, немає адреси</Tag>
            ),
        },
      ] }
    />
  );
});
